import {
  compose_email_custom_block_type_button,
  compose_email_custom_block_type_discount,
  compose_email_custom_block_type_early_bird,
} from "common/Components/ExlyComposeEmailRTE/Rte.constants";
import { CUSTOM_BLOCK_SEPARATOR } from "ui/pages/EmailDrip/EmailDrip.constants";

export const hasImage = (htmlString) => /<img[^>]+src="[^"]+"/.test(htmlString);

export const hasVideo = (htmlString) =>
  /<video[^>]+src="[^"]+"/.test(htmlString);

function replaceDollarSigns(inputStr) {
  const outputStr = inputStr.replace(/\${2}(.+?)\${2}/g, " $1 ");
  return outputStr.trim();
}

export const getPlainText = (htmlString) => {
  // Remove images, videos, style tags and their children
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlString;

  tempElement
    .querySelectorAll("img, video, style")
    .forEach((node) => node.remove());

  // Remove all HTML tags to get a plain text string
  const plainText = tempElement.innerText;
  // handle for vaiables
  return replaceDollarSigns(plainText);
};

export const getEmailPreviewFromHtmlString = (htmlString, meta_info) => {
  const separatedBlock = htmlString.split(CUSTOM_BLOCK_SEPARATOR)[0];
  const plainText = getPlainText(separatedBlock);
  if (plainText) return plainText;
  if (meta_info?.type === compose_email_custom_block_type_button)
    return "<Button>";
  if (meta_info?.type === compose_email_custom_block_type_discount)
    return "<Discount>";
  if (meta_info?.type === compose_email_custom_block_type_early_bird)
    return "<Limited-Offer>";
  if (hasImage(separatedBlock)) return "<Image>";
  if (hasVideo(separatedBlock)) return "<Video>";
  return "";
};

export const getLinksUsedInHtml = (htmlString) => {
  const parser = new DOMParser();
  const doc = parser.parseFromString(htmlString, "text/html");

  const links = Array.from(doc.querySelectorAll("a"))
    .filter((link) => {
      if (!link.textContent.trim()) return false; /// content is not empty
      try {
        new URL(link.href); // and link is valid
      } catch (e) {
        return false;
      }
      return true;
    })
    .map((link) => ({
      link_text: link.textContent.trim(),
      hyperlink: link.href,
    }));

  return links;
};

/**
 * Modifies an HTML string containing an iframe element by setting the width to 100%
 * and the position to 'inherit' if the iframe is found.
 *
 * @param htmlString - The HTML string to be processed.
 * @returns The modified HTML string with iframe width set to 100% and position set to 'inherit',
 *          or the original HTML string if no iframe is found.
 */
export const handleIframeHtmlString = (htmlString) => {
  // Create a temporary element to parse the HTML string
  const tempElement = document.createElement("div");
  tempElement.innerHTML = htmlString;

  // Find the first iframe element in the parsed HTML
  const iframeElement = tempElement.querySelector("iframe");
  if (iframeElement) {
    // handle wirdth and position
    iframeElement.style.width = "100%";
    iframeElement.style.position = "inherit";
    return tempElement.innerHTML;
  }
  // If no iframe is found, return the original HTML string
  return htmlString;
};
